import PayslipStructurecomp from '../components/payslipStructure';
const PayslipStructure = () => {

  return (
    <PayslipStructurecomp/>
  );
};

export default PayslipStructure;
